<script lang="ts" setup>
defineProps<{ amount: number | null }>();
</script>

<template>
  <div
    v-if="amount"
    class="loyalty-badge"
  >
    {{ amount }}

    <SvgoLogoH
      :font-controlled="false"
      class="size-2 sm:size-2.5"
      filled
    />
  </div>
</template>

<style lang="scss" scoped>
.loyalty-badge {
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 4px;
  justify-content: center;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  background-color: $hell-black;
  color: $white;
  font-size: $text-3xs;

  @include screen-sm {
    font-size: $text-2xs;
  }
}
</style>
